import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const SettingsContext = createContext(null);

export const SettingsProvider = ({ children }) => {
    const [settings, setSettings] = useState(null);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/site-settings");
            setSettings(data);
        } catch {
            setSettings({});
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    return (
        <SettingsContext.Provider value={{ settings: settings || {}, refresh }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);
